export const galerieData = [
  {
    image: "https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/064056eb4ccae0b3658c75372a28746a.jpeg",
    caption: "Notre terrasse accueillante"
  },
  {
    image: "https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/4e2c3709cf746d1153557facf0531a14.png",
    caption: "Tartare de thon signature"
  },
  {
    image: "https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/bb515eb0312fb6ae537f96bda2101909.jpeg",
    caption: "Bar & cocktails"
  },
  {
    image: "https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/d5c9140df5d75f3b09ab455ec04f8f3c.jpeg",
    caption: "Mahi mahi crème vanille"
  },
  {
    image: "https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/6e2e3d281701fc2352de3c868497de9d.jpeg",
    caption: "Ambiance en soirée"
  },
  {
    image: "https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/cde9d61151ddab1ad51ad6dd86ae2067.png",
    caption: "Magret de canard au miel"
  },
  {
    image: "https://public.readdy.ai/ai/img_res/860eb985451c10ca019ce0d88fbd9a88.jpg",
    caption: "Cocktails maison"
  },
  {
    image: "https://readdy.ai/api/search-image?query=Decadent%20molten%20chocolate%20lava%20cake%20with%20vanilla%20ice%20cream%20on%20white%20plate%20clean%20simple%20background%20soft%20natural%20lighting%20dessert%20photography%20high%20quality%20restaurant%20presentation&width=800&height=800&seq=keiki-gallery-dessert-001&orientation=squarish",
    caption: "Desserts gourmands"
  },
  {
    image: "https://static.readdy.ai/image/9db8f8eb12b800581950d7f0f98989ce/2b30fdd8148298568860fd7088e03a6f.png",
    caption: "Bienvenue chez KEIKI"
  }
];